export const permissionTranslations = {
    groups: {
        'lead.leads_management_common': {
            ru: 'Лиды (Общее)',
            en: 'Leads (General)',
        },
        'lead.payments_management': {
            ru: 'Платежи',
            en: 'Payments',
        },
        'lead.orders_management': {
            ru: 'Сделки',
            en: 'Orders',
        },
        'lead.payment_methods_management': {
            ru: 'Методы платежей',
            en: 'Payment Methods',
        },
        'user.admin_accounts_management': {
            ru: 'Аккаунты администраторов',
            en: 'Admin Accounts',
        },
        'user.customer_accounts_management': {
            ru: 'Аккаунты аффилиаторов',
            en: 'Affiliate Accounts',
        },
        'user.desks_management': {
            ru: 'Отделы',
            en: 'Departments',
        },
        'user.admin.roles_management': {
            ru: 'Роли администратора',
            en: 'Admin Roles',
        },
        'Без группы': {
            ru: 'Разное',
            en: 'Miscellaneous',
        }
    },

    names: {
        'lead.leads_management_common': {
            ru: 'Доступ к лидам',
            en: 'Lead Access',
        },
        'lead.leads_management_comments': {
            ru: 'Доступ к комментариям лидов',
            en: 'Lead Comments Access',
        },
        'user.admin_accounts_management': {
            ru: 'Тип администрирования',
            en: 'Administration Type',
        },
    }
};

const englishPermissionOverrides = {
    'lead.work_with_deleted_leads': 'Work with Deleted Leads',
    'lead.leads_management_common.all': 'Access to All Leads',
    'lead.leads_management_common.desk': 'Access to Desk Leads',
    'lead.leads_management_common.assigned': 'Access to Assigned Leads',
    'lead.get_platform_login': 'Login as Lead on Platform',
    'lead.leads_management_comments.all': 'Access to All Lead Comments',
    'lead.leads_management_comments.assigned': 'Access to Assigned Lead Comments',
    'lead.work_with_bonus': 'Work with Bonus Payments',
    'lead.work_with_deposit': 'Work with Deposit Payments',
    'lead.work_with_withdraw': 'Work with Withdrawals',
    'lead.change_lead_balance': 'Change Lead Balance',
    'lead.upsert_lead_deposit_methods': 'Manage Lead Payment Methods',
    'user.admin_accounts_management.all': 'Manage All Admin Accounts',
    'user.admin_accounts_management.desk': 'Manage Desk Admin Accounts',
    'user.change_admin_permissions': 'Change Admin Permissions',
};

const objectLabelByKey = {
    leads: 'Leads',
    deleted_leads: 'Deleted Leads',
    lead_comments: 'Lead Comments',
    orders: 'Orders',
    payments: 'Payments',
    bonus: 'Bonus Payments',
    deposit: 'Deposit Payments',
    withdraw: 'Withdrawals',
    platform_login: 'Platform Login',
    lead_balance: 'Lead Balance',
    lead_logs: 'Lead Logs',
    deposit_methods: 'Payment Methods',
    lead_deposit_methods: 'Lead Payment Methods',
    admin_accounts: 'Admin Accounts',
    affiliator_accounts: 'Affiliate Accounts',
    desks: 'Desks',
    roles: 'Roles',
    contact_us_requests: 'Contact Us Requests',
};

const actionLabelByKey = {
    create: 'Create',
    list: 'View',
    update: 'Update',
    delete: 'Delete',
    block: 'Block/Unblock',
    close: 'Close',
    get: 'Access',
    upsert: 'Manage',
    change: 'Change',
};

const titleCase = (value) =>
    String(value || '')
        .split(/[_\s]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

const buildEnglishPermissionLabel = (permissionName) => {
    if (!permissionName) return '';

    if (englishPermissionOverrides[permissionName]) {
        return englishPermissionOverrides[permissionName];
    }

    const [, action, ...rest] = permissionName.split('.');
    if (!action) return titleCase(permissionName);

    const actionLabel = actionLabelByKey[action] || titleCase(action);
    const objectKey = rest.join('_');
    const objectLabel = objectLabelByKey[objectKey] || titleCase(objectKey);

    return `${actionLabel} ${objectLabel}`.trim();
};

const buildEnglishPermissionDescription = (permissionName, fallbackLabel) => {
    const label = fallbackLabel || buildEnglishPermissionLabel(permissionName);
    if (!label) return '';

    return `Allows ${label.charAt(0).toLowerCase()}${label.slice(1)}.`;
};

export const getPermissionLabel = (permission, langSelected = 'ru') => {
    if (!permission) return '';

    const permissionName = permission.name;
    const translatedLabel = permissionTranslations.permissions?.[permissionName]?.[langSelected];
    if (translatedLabel) {
        return translatedLabel;
    }

    if (langSelected === 'en') {
        return buildEnglishPermissionLabel(permissionName) || permission.display_name || permissionName;
    }

    return permission.display_name || permissionName;
};

export const getPermissionDescription = (permission, langSelected = 'ru') => {
    if (!permission) return '';

    const permissionName = permission.name;
    const translatedDescription = permissionTranslations.descriptions?.[permissionName]?.[langSelected];
    if (translatedDescription) {
        return translatedDescription;
    }

    if (langSelected === 'en') {
        return buildEnglishPermissionDescription(permissionName, getPermissionLabel(permission, langSelected))
            || permission.display_description
            || '';
    }

    return permission.display_description || '';
};
